<template>
    <footer class="app-footer">
        <div class="container app-footer__grid">
            <section class="app-footer__col">
                <h4 class="app-footer__title">{{ t('footer.addressTitle') }}</h4>
                <p class="app-footer__brand">{{ t('contact.company') }}</p>
                <p class="app-footer__line">{{ t('contact.person') }}</p>
                <p class="app-footer__line">{{ t('contact.street') }}</p>
                <p class="app-footer__line">{{ t('contact.city') }}</p>
            </section>

            <section class="app-footer__col">
                <h4 class="app-footer__title">{{ t('footer.contactTitle') }}</h4>
                <p class="app-footer__line">
                    <i class="dx-icon dx-icon-tel app-footer__icon" aria-hidden="true"></i>
                    <a :href="`tel:${t('contact.phoneTel')}`">{{ t('contact.phone') }}</a>
                </p>
                <p class="app-footer__line">
                    <i class="dx-icon dx-icon-print app-footer__icon" aria-hidden="true"></i>
                    <span>{{ t('contact.fax') }}</span>
                </p>
                <p class="app-footer__line">
                    <i class="dx-icon dx-icon-email app-footer__icon" aria-hidden="true"></i>
                    <a :href="`mailto:${t('contact.email')}`">{{ t('contact.email') }}</a>
                </p>
            </section>

            <section class="app-footer__col">
                <h4 class="app-footer__title">{{ t('footer.legalTitle') }}</h4>
                <p class="app-footer__line">
                    <RouterLink :to="{ name: 'imprint' }">{{ t('footer.imprint') }}</RouterLink>
                </p>
                <p class="app-footer__line">
                    <RouterLink :to="{ name: 'privacy' }">{{ t('footer.privacy') }}</RouterLink>
                </p>
            </section>
        </div>
        <div class="container app-footer__bottom">
            <p class="app-footer__copy">{{ t('footer.copyright', { year }) }}</p>
        </div>
    </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'

const { t } = useI18n()
const year = computed(() => new Date().getFullYear())
</script>

<style scoped>
.app-footer {
    background-color: var(--gc-black);
    color: #ededed;
    margin-top: clamp(3rem, 6vw, 5rem);
    padding-block: clamp(2.5rem, 5vw, 4rem) 1.5rem;
    border-top: 4px solid var(--gc-accent);
}

.app-footer__grid {
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr;
}

@media (min-width: 720px) {
    .app-footer__grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

.app-footer__title {
    color: var(--gc-accent);
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    margin: 0 0 1rem 0;
}

.app-footer__brand {
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 0.5rem;
}

.app-footer__line {
    margin: 0 0 0.5rem 0;
    color: #b8b8b8;
    display: flex;
    align-items: center;
    gap: 0.6rem;
}

.app-footer__line a {
    color: #ededed;
    text-decoration: none;
    transition: color 160ms ease;
}

.app-footer__line a:hover {
    color: var(--gc-accent);
    text-decoration: underline;
}

.app-footer__icon {
    color: var(--gc-accent);
    font-size: 1rem;
    flex-shrink: 0;
}

.app-footer__bottom {
    margin-top: 2rem;
    padding-top: 1.25rem;
    border-top: 1px solid #262626;
    text-align: center;
}

.app-footer__copy {
    margin: 0;
    color: #888888;
    font-size: 0.85rem;
}
</style>
